import { platformConfig } from "apiUtils/ZnPlayer"
import { streamTypeEnum, userActionEnum } from "@/common/enums"
import { isIOS, isWX, SDK_PLATFORM } from 'utils/index'
import Hls from 'hls.js'

export const QINIU_STREAM_TYPE = {
  MAIN: 0, // 主流
  SAHRE: 1, // 分享流
  MIC: 2, // 连麦流
  MIX: 3, // 混流
}

export const QINIU_STREAM_STATUS = {
  START: 0, // 开始
  STOP: 1, // 结束
  REFRESH: 2, // 更新
}

// const MIXSTREAM = 'MIXSTREAM'

export const formatQNUrl = ({ roomId, hlsPlayUrl, stream, platform = 3 }) => {
  if (!stream) return
  if (platform !== SDK_PLATFORM.QI_NIU) {
    return stream?.mixPlayUrl || stream?.hlsPlayUrl
  }
  const { streamId, type } = stream
  return `${hlsPlayUrl.replace(/http:/, 'https:')}${roomId}_${streamId}_${type}.m3u8`
}


// 判断是否需要跳转到PC开播观看页
export const checkPCMode = (streamArr, liveMode, _this) => {
  const mainStream = streamArr.find((stream) => stream.type === QINIU_STREAM_TYPE.MAIN)
  if (
    mainStream
    && [streamTypeEnum.PC_CAERMA, streamTypeEnum.PC_SHARE_DES, streamTypeEnum.PC_SHARE_WINDOW, streamTypeEnum.PC_MEDIA, streamTypeEnum.WEB_CAMERA].indexOf(mainStream.st) >= 0
    && !_this.$route.name?.includes('shareLive')
  ) {
    _this.gotoShareLive()
    return 1
  }
}

// 判断是否需要跳转到手机开播竖版观看页
export const checkAppMode = (streamArr, liveMode, _this: any) => {
  let pcMode = [3, 4]
  const mainStream = streamArr.find((stream) => stream.type === QINIU_STREAM_TYPE.MAIN)
  if (
    pcMode.indexOf(+liveMode) < 0
    && mainStream
    && [
      streamTypeEnum.PC_CAERMA,
      streamTypeEnum.PC_SHARE_DES,
      streamTypeEnum.PC_SHARE_WINDOW,
      streamTypeEnum.PC_MEDIA,
      streamTypeEnum.WEB_CAMERA,
      // streamTypeEnum.MIX_STREAM, 混流不要判断？
      // streamTypeEnum.PC_AUDIO, pc音频也是往app页面跳转
    ].indexOf(mainStream.st) < 0
    && mainStream.st > 0
    && !_this.$route.name?.includes('shareCarLive')
  ) {
    _this.gotoShareCarLive()
    return 1
  }
}

const checkPage = {
  'shareLive': checkAppMode,
  'shareCarLive': checkPCMode,
  'guanjia-shareLive': checkAppMode,
  'guanjia-shareCarLive': checkPCMode,
}

// RTMP开播根据流的尺寸 跳转页面
const onLink = (mainSrc, _this) => {
  if (isIOS() && isWX()) return
  if (document.getElementById('rtmpVideo')) {
    return
  }
  const tempCont: any = document.getElementById('apps')
  let tempVideo: any = document.createElement('video')
  tempVideo.setAttribute('style', "display: none")
  tempVideo.src = mainSrc
  tempVideo.muted = false
  tempVideo.autoplay = true
  tempVideo.id = 'rtmpVideo'
  let hls = window.hls
  if (!hls) hls = new Hls()
  hls.loadSource(mainSrc)
  hls.attachMedia(tempVideo)
  tempVideo.onloadeddata = (e) => {
    if (!e.target.videoWidth || !e.target.videoHeight) return
    if (e.target.videoWidth < e.target.videoHeight && _this.$route.name?.includes('shareLive')) {
      _this.gotoShareCarLive()
      _this.$store.dispatch('setSkipRTMP', 1)
    }
    if (e.target.videoWidth >= e.target.videoHeight && _this.$route.name?.includes('shareCarLive')) {
      _this.$store.dispatch('setSkipRTMP', 1)
      _this.gotoShareLive()
    }
    hls.destroy()
    tempCont.removeChild(tempVideo)
  }
  tempCont.appendChild(tempVideo)
}

/**
 * 进入直播间获取流地址逻辑
 * @param param0 其他参数
 * @param _this 组件this
 */
export const entryLiveRoomQiNiu = async ({ roomId, sid }, _this) => {
  const QN_Res: any = await platformConfig[_this.sdkPlatform].getRoomStreamInfo({ roomId, sid })
  if (+QN_Res?.code === 0) {
    const { pullStreams = [], hlsPlayUrl, mixStream } = QN_Res.body
    // 找主流
    const mainStream = pullStreams.find((stream) => stream.type === QINIU_STREAM_TYPE.MAIN)
    const relStream = mixStream || mainStream
    _this.hlsPlayUrl = hlsPlayUrl
    const link = _this.$store.state.skipRTMP
    if (_this.liveMode === 4 && !link) {
      const mainSrc = formatQNUrl({ roomId, hlsPlayUrl, stream: mainStream, platform: _this.sdkPlatform }) || ''
      onLink(mainSrc, _this)
    }
    // 判断混流的主流设备，不同页面切换
    if (checkPage[_this.$route.name](pullStreams, _this.liveMode, _this)) {
      return 1
    }
    // 有混流或者主流的时候才能播放
    if (relStream) {
      const { streamId } = relStream
      _this.videoSource = [{
        refreshTime: Date.now(),
        sid: streamId,
        src: formatQNUrl({ roomId, hlsPlayUrl, stream: relStream, platform: _this.sdkPlatform }),
        videoType: "main",
        isPCStream: mixStream ? false : relStream.st === streamTypeEnum.PC_CAERMA,
      }]
      if (_this.liveMode === 4) {
        _this.$store.dispatch("setVideoSourceRTMP", {
          refreshTime: Date.now(),
          sid: streamId,
          url: formatQNUrl({ roomId, hlsPlayUrl, stream: relStream, platform: _this.sdkPlatform }),
          videoType: "main",
          isPCStream: mixStream ? false : relStream.st === streamTypeEnum.PC_CAERMA,
        });
      }
      _this.masterId = mainStream.userId
    } else {
      _this.liveMessageShow = true
      _this.liveMessageContent = "主播暂时离开"
      _this.saveLiveMessage()
    }
  }
  if (+QN_Res?.code === -4) {
    _this.noLoginInfo()
  }
}

// 更新流地址
const updateStream = (formatData, _this, mixLive = false, timeNumber = 8000) => {
  if (_this.fixTimer) clearTimeout(_this.fixTimer)
  _this.fixTimer = setTimeout(() => {
    _this.videoSource = [
      {
        sid: formatData.sid,
        refreshTime: Date.now(),
        src: formatData.url,
        videoType: "main",
        isPCStream: mixLive ? false : formatData.st === streamTypeEnum.PC_CAERMA,
      },
    ]
    _this.liveMessageShow = false
    _this.saveLiveMessage()
    _this.saveVideoSource(_this.videoSource)
  }, timeNumber)
}

// 停止拉流
const stopStream = (_this) => {
  _this.liveMessageShow = true
  _this.liveMessageContent = "主播暂时离开"
  _this.videoSource = []
  _this.stepOut = true
  _this.saveVideoSource([])
  _this.saveLiveMessage()
  if (_this.fixTimer) clearTimeout(_this.fixTimer)
}

/**
 * 监听七牛流变化IM消息
 * @param userAction 信令值
 * @param data 信令主体
 * @param hlsPlayUrl 流播放地址前缀
 * @param _this 组件this
 */
export const checkQNCMD = (data: any, _this) => {
  const userAction = parseInt(data.userAction, 10)
  if (+_this.liveMode === 4 && userAction === userActionEnum.STOP_PLAY_NOTIFY) {
    stopStream(_this)
    return 1
  }
  if (+_this.liveMode === 4 && userAction === userActionEnum.START_PLAY_NOTIFY) {
    updateStream(_this.$store.state.videoSourceRTMP, _this, _this.mixLive, 0)
    onLink(_this.$store.state.videoSourceRTMP.url, _this)
    return 1
  }
  if (userAction === userActionEnum.QINIU_DEFAULT_STREAM || userAction === userActionEnum.QINIU_MIX_STREAM) {
    const { actionParam, RoomId } = data
    const { userId, streamId } = actionParam
    const formatData = {
      ...actionParam,
      url: formatQNUrl({ roomId: RoomId, hlsPlayUrl: _this.hlsPlayUrl, stream: actionParam, platform: _this.sdkPlatform }),
      uid: userId,
      sid: streamId,
    }
    // 混流变更信令
    if (userAction === userActionEnum.QINIU_MIX_STREAM && _this.mixLive) {
      formatData.url = formatQNUrl({ roomId: RoomId, hlsPlayUrl: _this.hlsPlayUrl, stream: { ...actionParam, type: QINIU_STREAM_TYPE.MIX }, platform: _this.sdkPlatform })
      // 流停止
      if (+formatData.eventType === QINIU_STREAM_STATUS.STOP) {
        stopStream(_this)
        return 1
      }
      // 混流有更新,或者混流开始
      if (+formatData.eventType === QINIU_STREAM_STATUS.REFRESH || +formatData.eventType === QINIU_STREAM_STATUS.START) {
        updateStream(formatData, _this, _this.mixLive)
        return 1
      }
    }
    // 普通流信令，如果没有开启混流的直播间进来需要监听主流变化，更新流地址
    if (userAction === userActionEnum.QINIU_DEFAULT_STREAM && +formatData.type === QINIU_STREAM_TYPE.MAIN) {
      if (_this.liveMode === 4) {
        if (formatData.eventType) {
          stopStream(_this)
        } else {
          updateStream(formatData, _this)
        }
        onLink(formatData.url, _this)
      }
      // 只有主流变化才执行以下逻辑
      // 页面跳转判断
      if (checkPage[_this.$route.name]([formatData], _this.liveMode, _this)) {
        return 1
      }
      // 更新主播ID
      _this.masterId = formatData.userId

      // 没有混流的情况，监听主流变化，更新流地址
      if (+formatData.eventType === QINIU_STREAM_STATUS.START && !_this.mixLive) {
        updateStream(formatData, _this)
      }
      // 停止拉流
      if (+formatData.eventType === QINIU_STREAM_STATUS.STOP && !_this.mixLive) {
        stopStream(_this)
      }
    }
    return 1
  }
}
